import { useState, useEffect } from 'react';
import { HVARiskCategoriesTable } from 'components/tables/HVARiskCategoriesTable';
import {
  fetchHVARiskCategories,
  HVARiskCategory
} from 'services/hvarisk.service';

const RiskCategoryList: React.FC = () => {
  const [categories, setCategories] = useState<HVARiskCategory[]>([]);

  const loadCategories = async (): Promise<void> => {
    try {
      const fetchedCategories = await fetchHVARiskCategories();
      setCategories(fetchedCategories);
    } catch (error) {
      console.error('Error loading risk categories:', error);
    }
  };

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <div>
      <div className="mb-2">
        <HVARiskCategoriesTable
          categories={categories}
          onCategoriesChange={loadCategories}
        />
      </div>
    </div>
  );
};

export default RiskCategoryList;
